export const fetchToken = async (email, password, base_url, setToken, setError) => {
    try {
        const response = await fetch(`${base_url}/core/users/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                email,
                password
            })
        });

        // Handle network errors
        if (!response) {
            setError('Could not connect to the server. Please check your internet connection and try again.');
        }

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.msg || 'Login failed');
        }

        setToken(data.token);
    } catch (error) {
        console.error(error);
        setError(error.message)
    }
}